import React, { useMemo } from "react";
import { NumericFormat as NumericFormatBase } from "react-number-format";
import { Icon as IconBase, InputAdornment, TextField } from "@mui/material";
import RpSvgIcon from "@/components/icons/RpSvgIcon";

type LocationBrandMatchProps = {
  contribution?: string | number;
};

const NumericFormat = NumericFormatBase as React.ComponentType<any>;
const Icon = IconBase as React.ComponentType<any>;

export default function LocationBrandMatch({
  contribution,
}: LocationBrandMatchProps) {
  const value = useMemo(
    () =>
      contribution || parseFloat(String(contribution)) === 0
        ? parseFloat(String(contribution))
        : "",
    [contribution]
  );

  return (
    <div className="location-budget location-brand-match">
      <label>Brand Match</label>
      <NumericFormat
        customInput={TextField}
        value={value}
        name="locationBudget"
        id="locationBudget"
        thousandSeparator
        decimalScale={2}
        allowNegative={false}
        isAllowed={({ floatValue }) =>
          floatValue === undefined || floatValue <= 1000000
        }
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <Icon
                  component={RpSvgIcon}
                  name="money1"
                  color="primary"
                  fontSize="small"
                />
              </InputAdornment>
            ),
          },
        }}
        variant="outlined"
        size="small"
        autoComplete="off"
        placeholder="0.00"
        disabled={true}
      />
    </div>
  );
}
